// The old CRM host forwards to hub on the same page. index.html and public/auth-callback.html
// inline the same check as their first script; hubRedirect.test.ts keeps them in step.
export const OLD_CRM_HOST = "crm.volt-fraktionen-hamburg.org";
export const HUB_ORIGIN = "https://hub.volt-fraktionen-hamburg.org";

type PageLocation = Pick<Location, "hostname" | "pathname" | "search" | "hash">;

/** Target on hub for the old CRM host, null for every other host. */
export function hubRedirectTarget(loc: PageLocation): string | null {
  return loc.hostname === OLD_CRM_HOST
    ? HUB_ORIGIN + loc.pathname + loc.search + loc.hash
    : null;
}
